// extracted by mini-css-extract-plugin
module.exports = {"featuredCard":"style-module__featuredCard___3zjBq"};